<template>
        <!-- 账单明细列表 -->
        <el-table :key="0" :data="list" stripe v-loading="loading" :element-loading-text="loadingText" border
                    fit highlight-current-row class="w-100">

            <!-- 保单号 -->
            <el-table-column align="left" label="保单号" >
            <template slot-scope="scope">
                <span>{{scope.row.policy_number}}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="被保人姓名" >
            <template slot-scope="scope">
                <span>{{scope.row.name_of_the_insured}}</span>
            </template>
            </el-table-column>

<!--            <el-table-column align="left" label="签单保费" >-->
<!--            <template slot-scope="scope">-->
<!--                <span>{{ scope.row.signing_premiums | parsecurrency }}</span>-->
<!--            </template>-->
<!--            </el-table-column>-->

            <el-table-column align="left" label="增值税" >
            <template slot-scope="scope">
                <span>{{ scope.row.vat | parsecurrency }}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="签单保费" >
            <template slot-scope="scope">
                <span>{{ scope.row.premium | parsecurrency }}</span>
            </template>
            </el-table-column>



            <el-table-column align="left" label="签单日期" >
            <template slot-scope="scope">
                <span>{{scope.row.date_of_signing | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="起保日期" >
            <template slot-scope="scope">
                <span>{{scope.row.effective_date | parseTime('{y}年{m}月{d}日') }}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="结算手续费" >
            <template slot-scope="scope">
                <span>{{ scope.row.commission | parsecurrency }}</span>
            </template>
            </el-table-column>

            <el-table-column align="left" label="手续费/佣金率" >
            <template slot-scope="scope">
                <span>{{scope.row.commission_rate }}</span>
            </template>
            </el-table-column>

<!--            <el-table-column align="left" label="保单终止日期" >-->
<!--            <template slot-scope="scope">-->
<!--                <span>{{scope.row.policy_termination_date | parseTime('{y}年{m}月{d}日') }}</span>-->
<!--            </template>-->
<!--            </el-table-column>-->
        </el-table>
</template>

<script>
import { formatCurrency } from '@/utils/misc'
import { parseTime } from '@/utils'
export default {
    name: 'billing-record-list-tai-bao-dong-guan',
    components: {
    },
    filters: {
      parsecurrency: function(value){
        let v = parseFloat(value).toFixed(4)
        return formatCurrency(v, 2)
      },
    },
    props: [
        'list',
        'loading',
        'loadingText'
    ]
}
</script>
<style lang="scss">

</style>
